<div class="flex flex-col gap-5 p-10">
    <h3 class="text-orange-900 text-center mx-auto max-w-[10rem]">{{ data.reason == 'time' ? 'Time Up!' : ''}}
        {{ data.text }}</h3>
    <div class="flex items-center gap-3">
        <button type="button" mat-raised-button class="mr-3" (click)="option(0)">No, Return to Test</button>
        <button type="button" mat-raised-button (click)="option(1)" color="primary" class="float-right">Yes,
            Submit</button>
    </div>
</div>